import {update} from './GridUtils';

function formatLabelDD({deg}: {deg: number}) {
    if (deg > 180) {
        deg -= 360;
    } else if (deg < -180) {
        deg += 360;
    }
    if (deg === -180) {
        deg = 180;
    }
    return `${Number(deg.toFixed(4))}°`;
}

const coordinateGridSpacing = [
    20.0, // 0
    20.0, // 1
    20.0, // 2
    10.0, // 3
    5.0, // 4
    5.0, // 5
    2.0, // 6
    1.0, // 7
    1.0, // 8
    0.5, // 9
    0.25, // 10
    0.10, // 11
    0.05, // 12
    0.025, // 13
    0.01, // 14
    0.005, // 15
    0.0025, // 16
    0.0001, // 17
    0.01, // 18
];

const DecimalDegreeGrid: GridGenerator = function (
    bounds: mapboxgl.LngLatBounds,
    zoom: number
): mapboxgl.Style {
    return update({
        id: 'lng|lat|dd',
        bounds,
        zoom,
        coordinateGridSpacing,
        labelFunc: formatLabelDD
    });
};

export default DecimalDegreeGrid;
